import {
  InactiveDaysWidgetProps,
  WidgetConfig,
  WidgetDataDependencies,
  WidgetType,
} from '../../types/widget-manager.types';
import { BaseWidgetStrategy } from './base-widget-strategy';

/**
 * Stocks widget strategy
 * Returns: InactiveDays, MaxLoss, DailyLimit, Payout widgets
 */
export class StocksWidgetStrategy extends BaseWidgetStrategy {
  getWidgetConfigs(data: WidgetDataDependencies): WidgetConfig[] {
    if (!this.validateData(data)) {
      return [];
    }

    const configs: WidgetConfig[] = [];

    // InactiveDays widget (Stocks-specific)
    configs.push({
      type: WidgetType.InactiveDays,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
      } as InactiveDaysWidgetProps,
      enabled: true,
      order: 1,
    });

    // MaxLoss widget
    configs.push({
      type: WidgetType.MaxLoss,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
      },
      enabled: true,
      order: 2,
    });

    // DailyLimit widget
    configs.push({
      type: WidgetType.DailyLimit,
      props: {
        account: data.account,
        accountBalance: data.accountBalance,
        program: data.program,
      },
      enabled: true,
      order: 3,
    });

    // Payout widget
    configs.push({
      type: WidgetType.Payout,
      props: {
        account: data.account,
        eligibilityData: data.eligibilityData,
      },
      enabled: true,
      order: 4,
    });

    // Sort by order and filter valid configs
    return this.filterValidConfigs(configs).sort((a, b) => {
      const orderA = a.order ?? 999;
      const orderB = b.order ?? 999;
      return orderA - orderB;
    });
  }
}
